import { render, staticRenderFns } from "./CommentFormLoggedin.vue?vue&type=template&id=ff218b2a&"
import script from "./CommentFormLoggedin.vue?vue&type=script&lang=js&"
export * from "./CommentFormLoggedin.vue?vue&type=script&lang=js&"
import style0 from "./CommentFormLoggedin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports